import React from 'react';
import {SuggestPropsInterface} from "./Suggest.props.interface";
import Select from "../Select";
import Input from "../Input";

const Suggest: React.FC<SuggestPropsInterface> = (
    {
        direction,
        visibilityItems = 5,
        size = 'small',
        data = {},
        parentRef,
        placeholder = '',
        disabled = false,
        maxLength = undefined,
        label = undefined,
        value = undefined,
        error = undefined,
        selectedValues = undefined,
        isMulti = false,
        prefix,
        suffix,
        onInput,
        onClick,
        onChange,
        onDropShow,
        onDropHide,
        onReachEnd,
        isClearable = false,
        className = undefined,
        ...rest
    }) => {

    return (
        <Select
            direction={direction}
            visibilityItems={visibilityItems}
            size={size}
            data={data}
            value={selectedValues}
            isMulti={isMulti}
            disabled={disabled}
            onDropShow={onDropShow}
            onDropHide={onDropHide}
            onReachEnd={onReachEnd}
            parentRef={parentRef}
            onChange={onChange}
        >
            <Input
                prefix={prefix}
                suffix={suffix}
                label={label}
                size={size}
                value={value}
                error={error}
                className={className}
                onClick={onClick}
                placeholder={placeholder}
                disabled={disabled}
                maxLength={maxLength}
                onChange={onInput}
                isClearable={isClearable}
            />
        </Select>
    );
};
export default Suggest;
